import { useRequiredContext } from "@redotech/react-util/context";
import { Elements } from "@stripe/react-stripe-js";
import { StripeElementsOptions } from "@stripe/stripe-js";
import { ReactNode } from "react";
import { StripeContext } from ".";

export function StripeElements({
  children,
  options,
}: {
  children?: ReactNode | ReactNode[];
  options?: StripeElementsOptions;
}) {
  const stripe = useRequiredContext(StripeContext);
  return (
    <Elements options={options} stripe={stripe()}>
      {children}
    </Elements>
  );
}
